export default {
	install: Vue => {
		// Filtro para pasar de segundos a horas
		Vue.filter('hora', segundosEntrada => {
			// Obtenemos el valor absoluto
			let sec = Math.abs(segundosEntrada)
			let horas, minutos, segundos
			horas = Math.floor(sec / 3600)
			minutos = Math.floor((sec % 3600) / 60)
			segundos = Math.floor(sec % 60)

			horas = horas < 10 ? '0' + horas.toString() : horas.toString()
			minutos = minutos < 10 ? '0' + minutos.toString() : minutos.toString()
			segundos = segundos < 10 ? '0' + segundos.toString() : segundos.toString()

			const signo = segundosEntrada < 0 ? '-' : ''
			return signo + '' + horas + ':' + minutos + ':' + segundos
		})

		/**
		 * Devuelve la fecha en formato AAAA-MM-DD a partir de los segundos
		 */
		Vue.filter('fecha', segundos => {
			const fecha = new Date(segundos * 1000)
			const ano = fecha.getUTCFullYear().toString()
			let mes = fecha.getUTCMonth() + 1
			let dia = fecha.getUTCDate()
			mes = mes - 10 ? '0' + mes.toString() : mes.toString()
			dia = dia - 10 ? '0' + dia.toString() : dia.toString()
			return ano + '-' + mes + '-' + dia
		})

		/**
		 * Transforma una fecha en formato AAAA-MM-DD o una hora en formato HH:MM:SS
		 * a segundos
		 */
		Vue.filter('segundos', cadena => {
			const expHora = /^-?\d{2}:\d{2}(:\d{2})?$/
			const expFecha = /^\d{4}-\d{2}-\d{2}$/

			if (expHora.test(cadena)) {
				// Es una hora
				let positivo = 1
				if (cadena[0] === '-') {
					positivo = -1
					cadena.splice(0, 1)
				}
				const arr = cadena.split(':')
				const sec = arr.length === 3 ? parseInt(arr[2], 10) : 0
				const segundos = parseInt(arr[0], 10) * 3600 + parseInt(arr[1], 10) * 60 + sec
				return segundos * positivo
			} else if (expFecha.test(cadena)) {
				// Es una fecha
				const arr = cadena.split('-')
				const ano = parseInt(arr[0], 10)
				const mes = parseInt(arr[1], 10) - 1
				const dia = parseInt(arr[2], 10)
				const fecha = new Date(ano, mes, dia, 0, 0, 0, 0)
				return Math.floor(fecha.getTime() / 1000)
			} else {
				return null
			}
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/core/vue/libs/filtroHora.js